<template>
    <div>
        <div v-if="!isLoading" class="">
            <div v-if="item" class="">
                <div class="row">
                    <div class="col-12">
                        <div class="card mb-4">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">Application Details</h5>
                            </div>
                            <div class="card-body position-relative">
                                <div class="row g-4 align-items-end">
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Status</label>
                                        <p class="mb-0"><span v-html="statusBadge(item.status)"></span></p>
                                    </div>
                                    <div class="col-sm-6">
                                        <label class="small text-muted">Selection Mode</label>
                                        <p class="mb-0">{{ item.selected_mode }}</p>
                                    </div>
                                    <div class="col-sm-6">
                                        <div v-if="item.status == 'applied'">
                                            <label class="small text-muted">Applied on</label>
                                            <p class="mb-0">{{ $filters.date(item.applied_at, 1) }}</p>
                                        </div>
                                        <div>
                                            <label class="small text-muted">Shortlisted on</label>
                                            <p class="mb-0">{{ $filters.date(item.shortlisted_at, 1) }}</p>
                                        </div>
                                    </div>
                                    <div class="col-sm-6">
                                        <div v-if="item.status == 'accepted_shortlisting'">
                                            <label class="small text-muted">Accepted Shortlisting on</label>
                                            <p class="mb-0">{{ $filters.date(item.accepted_shortlisting_at, 1) }}</p>
                                        </div>
                                        <div v-if="item.status == 'rejected_shortlisting'">
                                            <label class="small text-muted">Rejected Shortlisting on</label>
                                            <p class="mb-0">{{ $filters.date(item.rejected_shortlisting_at, 1) }}</p>
                                        </div>
                                    </div>
                                    <div v-if="item.status == 'invited_for_interview' && item.invitation"
                                        class="col-sm-6">
                                        <router-link class="text-reset text-decoration-underline"
                                            :to="`/interviews/${item.invitation.id}`">Click here to read more about
                                            interview</router-link>
                                    </div>
                                    <div v-if="item.rejected_notes" class="col-12">
                                        <label class="small text-muted"> Reason for rejection</label>
                                        <p v-html="preText(item.rejected_notes)" class="mb-0"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.opportunity && item.opportunity.category_id"
                            class="bd-callout mt-0 mb-4 bd-callout-warning">
                            <h4>You may cancel this application if you wish to apply for a different job opportunity
                                within the same <span v-if="item.opportunity.category"> {{
                                    item.opportunity.category.title }} </span> category. </h4>
                            <div class="pt-4">
                                <p class="mb-1">
                                    If you decide to apply for another role in this category, simply cancel your current
                                    application and proceed with the new one.
                                </p>
                                <div class="pt-4">
                                    <button @click="cancelApplication()" class="btn btn-warning" type="button">Cancel
                                        Application</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.status === 'shortlisted'" class="bd-callout mt-0 mb-4 bd-callout-warning">
                            <h4>You have been shortlisted for this opportunity. </h4>
                            <div class="pt-4">
                                <p class="mb-1">
                                    Please confirm your interest by either accepting or rejecting this shortlisting.
                                    Acceptance time expires at:
                                </p>
                                <div>
                                    <count-down-timer size="sm" body-class="mt-3"
                                        :deadline="item.acceptance_deadline" />
                                </div>
                                <div class="d-grid d-sm-flex pt-4 gap-3">
                                    <button @click="acceptShortlisting()" class="btn btn-primary w-100"
                                        type="button">Accept Shortlisting</button>
                                    <button @click="rejectShortlisting()" class="btn btn-warning w-100"
                                        type="button">Reject Shortlisting</button>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.invitation" class="card mb-4">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">Interview invitation</h5>
                                <router-link class="text-reset text-decoration-underline"
                                    :to="`/interviews/${item.invitation.id}`">Read more</router-link>
                            </div>
                            <div class="card-body position-relative">
                                <div class="row g-4">
                                    <div class="col-lg-6">
                                        <label class="small text-muted">Status</label>
                                        <p class="mb-0"><span v-html="statusBadge(item.invitation.status)"></span></p>
                                    </div>
                                    <div v-if="item.invitation.created_at" class="col-sm-6">
                                        <label class="small text-muted">Invited on</label>
                                        <p class="mb-0">{{ $filters.date(item.invitation.created_at, 1) }}</p>
                                    </div>
                                    <div v-if="item.invitation.accepted_at" class="col-sm-6">
                                        <label class="small text-muted">Accepted on</label>
                                        <p class="mb-0">{{ $filters.date(item.invitation.accepted_at, 1) }}</p>
                                    </div>
                                    <div v-if="item.invitation.rejected_at" class="col-sm-6">
                                        <label class="small text-muted">Rejected on</label>
                                        <p class="mb-0">{{ $filters.date(item.invitation.rejected_at, 1) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="item.opportunity">
                            <opportunity-detail-card :item="item.opportunity" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <is-loading v-else />
    </div>
</template>

<script>
import IsLoading from '@/components/IsLoading.vue'
import OpportunityDetailCard from '@/components/cards/OpportunityDetailCard.vue'
import CountDownTimer from '@/components/widgets/CountDownTimer.vue'

export default {
    name: "opportunity-match-show",
    components: {
        IsLoading,
        OpportunityDetailCard,
        CountDownTimer
    },
    data() {
        return {
            isLoading: true,
            popupModalShow: false,
            item: null,
        }
    },
    watch: {
        '$route.params.opportunityMatchId': function (id) {
            if (id) this.fetchItem()
        },
    },
    methods: {
        updateItem(item) {
            this.item = Object.assign(this.item, item);
        },
        fetchItem() {
            this.isLoading = true
            this.$http.get(`/opportunity-matches/${this.$route.params.opportunityMatchId}/show`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.item = response.data.data
                    } else {
                        this.$router.push({ path: '/error-404' })
                    }
                })
        },
        acceptShortlisting() {
            this.confirmAction({
                icon: 'success',
                html: "By accepting, you confirm your interest and move closer to the next phase. Are you ready to proceed?",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("changeLoaderValue", true)
                    this.$http.post(`/opportunity-matches/${this.item.id}/accept`)
                        .then(response => {
                            this.$store.dispatch("changeLoaderValue", false)
                            if (response.data.success) {
                                this.updateItem(response.data.data)
                            }
                        })
                }
            });
        },
        rejectShortlisting() {
            this.confirmAction({
                icon: 'warning',
                title: "You're about to decline this opportunity.",
                html: "By rejecting, you will no longer be considered for the next phase. Are you sure you want to proceed?",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("changeLoaderValue", true)
                    this.$http.post(`/opportunity-matches/${this.item.id}/reject`)
                        .then(response => {
                            this.$store.dispatch("changeLoaderValue", false)
                            if (response.data.success) {
                                this.updateItem(response.data.data)
                            }
                        })
                }
            });
        },
        cancelApplication() {
            this.confirmAction({
                icon: 'warning',
                title: "You're about to cancel this opportunity.",
                html: "By canceling, your submitted application will be terminated. Are you sure you want to proceed?",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("changeLoaderValue", true)
                    this.$http.delete(`/opportunity-matches/${this.item.id}/delete`)
                        .then(response => {
                            this.$store.dispatch("changeLoaderValue", false)
                            if (response.data.success) {
                                this.$router.push({ path: '/matched-opportunities' })
                            }
                        })
                }
            });
        },
        initializeAll() {
            this.popupModalShow = false;
        }
    },
    created() {
        this.fetchItem()
    },
}

</script>
